module.exports = require("@material-ui/icons/NotificationsPaused");